export const apiConfig = {
    policyLink: (): string => {
        throw new Error("You haven't set the gdpr forwarder endpoint");
    },
    termsLink: (): string => {
        throw new Error("You haven't set the terms forwarder endpoint");
    },
    externalServicesLink: (): string => {
        throw new Error("You haven't set the external services forwarder link");
    }
};
